import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstants} from '../global-constants';
import {SortDirection} from "@angular/material/sort";

@Injectable({
    providedIn: 'root'
})
export class ProviderService {

    constructor(private http: HttpClient) {
    }

    find(sort: string, order: SortDirection, page: number, size: number, search, showUnmappedOnly) {
        const sortParameter = sort ? `&sort=${sort},${order}` : '';
        const searchParameter = search ? `&search=${search}` : '';
        return this.http.get(`${GlobalConstants.apiURL}/providers/find?page=${page}&size=${size}&showUnmappedOnly=${showUnmappedOnly}${sortParameter}${searchParameter}&showUnmappedOnly`);
    }
}
